const styles = () => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    width: "40%",
    border: "none !important",
  },
  mobilePaper: {
    width: "80%",
    border: "none !important",
  },
  defaultBox: {
    display: "flex",
    alignItems: "center",
    borderRadius: "4px",
    background: "white",
  },
  defaultTitle: {
    marginRight: "8px",
  },
})

export default styles
